import React, { Fragment } from 'react';
import ReviewItem from './ReviewItem';
import PropTypes from 'prop-types';
import './styles.styl';

const ReviewSheet = ({ review }) => {
  return (
    <Fragment>
      {review.map((reviewItem, index) => {
        return (
          <ReviewItem
            questionNumber={index + 1}
            data={reviewItem}
            key={index}
          />
        );
      })}
    </Fragment>
  );
};

ReviewSheet.defaultProps = {
  review: []
};

ReviewSheet.propTypes = {
  review: PropTypes.array.isRequired
};

export default ReviewSheet;



// WEBPACK FOOTER //
// ../core/src/components/ReviewSheet/ReviewSheet.js